import React from "react";
import { IconType } from "./types";

const Error: IconType = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="#E02020"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M8.5 15C4.63401 15 1.5 11.866 1.5 8C1.5 4.13401 4.63401 1 8.5 1C12.366 1 15.5 4.13401 15.5 8C15.5 11.866 12.366 15 8.5 15ZM8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16Z"
      fill="inherit"
    />
    <path
      d="M7.50154 11C7.50154 10.4477 7.94926 10 8.50154 10C9.05383 10 9.50154 10.4477 9.50154 11C9.50154 11.5523 9.05383 12 8.50154 12C7.94926 12 7.50154 11.5523 7.50154 11Z"
      fill="inherit"
    />
    <path
      d="M7.5995 4.99504C7.54623 4.46228 7.96459 4 8.5 4C9.03541 4 9.45377 4.46228 9.4005 4.99504L9.04975 8.50248C9.02151 8.78492 8.78384 9 8.5 9C8.21616 9 7.97849 8.78492 7.95025 8.50248L7.5995 4.99504Z"
      fill="inherit"
    />
  </svg>
);

export default Error;
